import Hammer from 'hammerjs'

export default {
  beforeMount: function (el, binding, vnode) {
    if (typeof binding.value === 'function') {
      const mc = new Hammer(el)

      mc.get('pan').set({ direction: Hammer.DIRECTION_ALL, threshold: 0 })
      mc.on('pan', binding.value)
    }
  }
}
